import React from "react";
import { CondensedFeatureGrid } from "./CondensedFeatureGrid";
import { ICondensedFeatureGridProps } from "./CondensedFeatureGrid.types";
import { InView } from "react-intersection-observer";

export const CondensedFeatureGridInView = ({
  cards,
  isOverview,
}: Readonly<ICondensedFeatureGridProps>) => {
  return (
    <InView as="div" threshold={0.2} trackVisibility delay={100} initialInView>
      {({ inView, ref }) => (
        <div ref={ref}>
          <CondensedFeatureGrid
            cards={cards}
            isOverview={isOverview}
            isInView={inView}
          />
        </div>
      )}
    </InView>
  );
};
